import { useEffect, useState } from 'react';
import s from './DiagnosticsTab.module.scss';

const STATUS_ICON = { ok: '✓', warn: '!', fail: '✕' };
const STATUS_ORDER = { fail: 0, warn: 1, ok: 2 };

// Презентационный компонент: результат и его загрузка приходят из MainPage
// (там же тихий автозапуск при открытии приложения и бейдж в меню) - здесь
// только рендер и повторный ручной запуск через ту же onRun, что и автозапуск,
// поэтому вкладка и бейдж в меню всегда показывают один и тот же результат.
export default function DiagnosticsTab({ checks, loading, error, onRun }) {
    const [expanded, setExpanded] = useState({});
    const [passedOpen, setPassedOpen] = useState(false);

    useEffect(() => {
        if (!checks) return;
        // Проблемные пункты раскрываем сразу - инструкция на виду.
        // Срабатывает на каждый новый результат (в т.ч. автозапуск при открытии),
        // а не на клики по пунктам - toggle() checks не трогает
        const exp = {};
        checks.forEach(c => { if (c.status === 'fail' && c.instruction) exp[c.id] = true; });
        setExpanded(exp);
        setPassedOpen(false);
    }, [checks]);

    const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

    const problems = checks
        ? checks.filter(c => c.status !== 'ok').sort((a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status])
        : [];
    const passed = checks ? checks.filter(c => c.status === 'ok') : [];
    const failCount = problems.filter(c => c.status === 'fail').length;
    const warnCount = problems.filter(c => c.status === 'warn').length;

    const renderItem = (c) => {
        const openable = Boolean(c.instruction) && c.status !== 'ok';
        const open = Boolean(expanded[c.id]);
        return (
            <div key={c.id} className={s.item}>
                <div
                    className={`${s.row} ${openable ? s.rowClickable : ''}`}
                    onClick={() => openable && toggle(c.id)}
                >
                    <span className={`${s.icon} ${s['icon_' + c.status]}`}>
                        {STATUS_ICON[c.status] || '?'}
                    </span>
                    <div className={s.texts}>
                        <div className={s.itemTitle}>{c.title}</div>
                        <div className={s.itemMsg}>{c.message}</div>
                    </div>
                    {openable && (
                        <span className={`${s.chevron} ${open ? s.chevronOpen : ''}`}>›</span>
                    )}
                </div>
                {openable && (
                    <div className={`${s.instructionWrap} ${open ? s.instructionOpen : ''}`}>
                        <div className={s.instructionInner}>
                            <div className={s.instruction}>
                                <b>Что сделать: </b>{c.instruction}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={s.container}>
            <h2 className={s.title}>Самодиагностика</h2>
            <p className={s.hint}>
                Проверим основные настройки приложения: авторизацию на портале, соответствие полей,
                подключение hh.ru и подписку. Обычно занимает несколько секунд.
            </p>

            <div>
                <button className={s.runBtn} onClick={onRun} disabled={loading}>
                    {loading && <span className={s.spinner}/>}
                    {loading ? 'Проверяем…' : 'Провести самодиагностику'}
                </button>
            </div>

            {error && <div className={s.error}>{error}</div>}

            {checks && !loading && (
                <>
                    <div className={s.summary}>
                        {failCount === 0 && warnCount === 0 && 'Все проверки пройдены - настройки в порядке.'}
                        {failCount > 0 && `Найдено проблем: ${failCount}. Пункты с крестиком раскрыты - в них инструкция.`}
                        {failCount === 0 && warnCount > 0 && 'Критичных проблем нет, но есть что улучшить.'}
                    </div>

                    {problems.length > 0 && (
                        <div className={s.list}>
                            {problems.map(renderItem)}
                        </div>
                    )}

                    {passed.length > 0 && (
                        <div className={s.passedGroup}>
                            <div className={s.passedHead} onClick={() => setPassedOpen(v => !v)}>
                                <span className={`${s.icon} ${s.icon_ok}`}>✓</span>
                                <span className={s.passedTitle}>Пройдено: {passed.length}</span>
                                <span className={`${s.chevron} ${passedOpen ? s.chevronOpen : ''}`}>›</span>
                            </div>
                            <div className={`${s.instructionWrap} ${passedOpen ? s.instructionOpen : ''}`}>
                                <div className={s.instructionInner}>
                                    <div className={s.list}>
                                        {passed.map(renderItem)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
